import React from "react";
import Experience from "../Items/Experience";

const experiencesData = {
  Academic: [
    {
      id: 2,
      year: "2019 - 2021",
      degree: "Deep Analysis in Software development - Unifil",
      content:
        "Deep learning neural networks performance, modern hardware and software development and sophisticated software solutions.",
    },
    {
      id: 3,
      year: "2014 - 2019",
      degree: "Bachelor's Degree - Computer Engineering - UFU",
      content:
        "Design and development of systems based on computers and complex digital logic devices.",
    },
  ],
  Experiences: [
    {
      id: 1,
      year: "Currently",
      degree: "Senior Front-end Engineer / MERN Engineer",
      content:
        "Always working as a proactive team player reviewing PR's, prioritizing Backlog tasks, participating in Grooming meetings, developing new features with code: 100% Tested, 100% accessible and with high performance. \nI built a brand new application from scratch and also could contribute with App migrations - Entirely divided into reusable components. <br/> Stack: React, React-native, NodeJs, Typescript, Javascript, Tailwind, Nest, Firebase, AWS.",
    },
    {
      id: 2,
      year: "2019 - 2021",
      degree: "Senior Front-End Engineer at Ebay Inc (Avenue)",
      content:
        "I built a new application from scratch. Entirely divided into reusable components. From this, it was possible to attract new customers interested in buying and selling collectible cards. The built application moves millions of dollars every month. <br/>Stack: Typescript, React, and Several preprocessor style sheet languages such as Scss, Less, sass.",
    },
    {
      id: 3,
      year: "2018 - 2019",
      degree: "Front-end Developer at Cedrotech.com",
      content:
        "Solving complex problems using the latest in Mobile, and Web Technologies Utilized strong interpersonal and communications skills to serve customers<br/>Stack: Dart, TypeScript, Flutter, Angular 11, JavaScript, React-native, Expo, ReactJs, NodeJs, Nosql, AWS (EC2, Route53 & S3)",
    },
    {
      id: 4,
      year: "2016 - 2018",
      degree: "Full-Stack Developer at Dcnearshore.com",
      content:
        "I created the Diversidade+ app, the first Talent bank for PwD people in Brazil. Served as a mobile application developer, hardworking, and punctual employee. More than 3000 people with physical disabilities was found by large companies and more than 200 people to get a job <br/>Stack: JavaScript, React-native, Angular 7, NodeJs, Nosql",
    },
  ],
};

function Experiences({ title }) {
  return (
    <div className="timeline">
      {experiencesData[title].map((experience) => (
        <Experience experience={experience} key={experience.id} />
      ))}
      <span className="timeline-line"></span>
    </div>
  );
}

export default Experiences;
